import { useState } from "react";
import apple from "../../assets/apple.jpg";
import fyndmockup from "../../assets/fyndmockup.png";
import google from "../../assets/google.jpg";
import icone from "../../assets/icone.png";
import qrcode from "../../assets/qrcode.png";
import { autenticarUsuario } from "../../store/actions/usuario";
import { useNavigate } from "react-router-dom";

// ─── Ícone olho inline ───────────────────────────────────────────────────────
const EyeIcon = ({ off }) => off ? (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
) : (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

// ─── Alerta inline ────────────────────────────────────────────────────────────
function InlineAlert({ type, message }) {
  const colors = {
    error: { bg: "#fef2f2", border: "#fecaca", text: "#dc2626", icon: "✕" },
    success: { bg: "#f0fdf4", border: "#bbf7d0", text: "#16a34a", icon: "✓" },
  };
  const c = colors[type];
  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 8,
      background: c.bg, border: `1px solid ${c.border}`,
      borderRadius: 8, padding: "10px 14px",
      animation: "fadeSlide 0.2s ease",
    }}>
      <span style={{ color: c.text, fontWeight: 700, fontSize: 13 }}>{c.icon}</span>
      <span style={{ color: c.text, fontSize: 13, fontFamily: "Poppins, sans-serif" }}>{message}</span>
      <style>{`@keyframes fadeSlide { from { opacity:0; transform:translateY(-6px) } to { opacity:1; transform:translateY(0) } }`}</style>
    </div>
  );
}

function getErrorMessage(data) {
  if (!data.email && !data.password) return "Digite seu e-mail e senha para continuar.";
  if (!data.email) return "Por favor, informe seu e-mail.";
  if (!data.password) return "Por favor, informe sua senha.";
  return "E-mail ou senha incorretos. Tente novamente.";
}

function Login() {
  const navigate = useNavigate();
  const [showPass, setShowPass] = useState(false);
  const [data, setData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);

  async function sendLogin(event) {
    event.preventDefault();
    setLoading(true);
    try {
      const retornoLogin = await autenticarUsuario(data.email, data.password);
      setShowSuccessAlert(true);
      setTimeout(() => setShowSuccessAlert(false), 3000);
      if (retornoLogin.permissao.tipo === "ADMINISTRADOR" || retornoLogin.permissao.tipo === "INTEGRACAO") {
        navigate("/app/atendimento/finalizados", { replace: true });
      } else {
        navigate("/app/home", { replace: true });
      }
    } catch (error) {
      setShowErrorAlert(true);
      setTimeout(() => setShowErrorAlert(false), 3000);
    } finally {
      setLoading(false);
    }
  }

  const inputStyle = {
    width: "100%",
    padding: "11px 14px",
    fontSize: 13,
    fontFamily: "Poppins, sans-serif",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    outline: "none",
    background: "#fafafa",
    color: "#111827",
    boxSizing: "border-box",
    transition: "border-color 0.15s, box-shadow 0.15s",
  };

  return (
    <div style={{
      width: "100vw", height: "100vh",
      display: "flex", fontFamily: "Poppins, sans-serif",
      background: "#f8fafc",
    }}>

      {/* ── Painel esquerdo — formulário ───────────────────────────── */}
      <div style={{
        width: "45%", minWidth: 360,
        display: "flex", flexDirection: "column",
        justifyContent: "center", alignItems: "center",
        background: "#ffffff",
        boxShadow: "2px 0 20px rgba(0,0,0,0.06)",
        padding: "40px 32px",
        boxSizing: "border-box",
      }}>
        <div style={{ width: "100%", maxWidth: 360 }}>

          {/* Logo */}
          <div style={{ marginBottom: 28 }}>
            <img src={icone} alt="logo" style={{ height: 44, objectFit: "contain" }} />
          </div>

          {/* Heading */}
          <h1 style={{ margin: "0 0 4px", fontSize: 22, fontWeight: 700, color: "#111827" }}>
            Bem-vindo de volta
          </h1>
          <p style={{ margin: "0 0 28px", fontSize: 13, color: "#9ca3af" }}>
            Acesse sua conta para continuar
          </p>

          {/* Alertas */}
          <div style={{ marginBottom: showErrorAlert || showSuccessAlert ? 16 : 0 }}>
            {showErrorAlert && (
              <InlineAlert type="error" message={getErrorMessage(data)} />
            )}
            {showSuccessAlert && (
              <InlineAlert type="success" message="Login realizado! Redirecionando..." />
            )}
          </div>

          {/* Form */}
          <form onSubmit={sendLogin} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>E-mail</label>
              <input
                type="email"
                value={data.email}
                onChange={e => setData({ ...data, email: e.target.value })}
                placeholder="seu@email.com"
                style={inputStyle}
                onFocus={e => { e.target.style.borderColor = "#6366f1"; e.target.style.boxShadow = "0 0 0 3px rgba(99,102,241,0.1)"; }}
                onBlur={e => { e.target.style.borderColor = "#e5e7eb"; e.target.style.boxShadow = "none"; }}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>Senha</label>
              <div style={{ position: "relative" }}>
                <input
                  type={showPass ? "text" : "password"}
                  value={data.password}
                  onChange={e => setData({ ...data, password: e.target.value })}
                  placeholder="••••••••"
                  style={{ ...inputStyle, paddingRight: 42 }}
                  onFocus={e => { e.target.style.borderColor = "#6366f1"; e.target.style.boxShadow = "0 0 0 3px rgba(99,102,241,0.1)"; }}
                  onBlur={e => { e.target.style.borderColor = "#e5e7eb"; e.target.style.boxShadow = "none"; }}
                />
                <button
                  type="button"
                  onClick={() => setShowPass(v => !v)}
                  style={{
                    position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
                    background: "none", border: "none", cursor: "pointer",
                    color: "#9ca3af", display: "flex", alignItems: "center", padding: 0,
                  }}
                >
                  <EyeIcon off={showPass} />
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                marginTop: 4,
                padding: "11px",
                background: loading ? "#a5b4fc" : "#6366f1",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 600,
                fontFamily: "Poppins, sans-serif",
                cursor: loading ? "not-allowed" : "pointer",
                transition: "background 0.15s, transform 0.1s",
              }}
              onMouseEnter={e => { if (!loading) e.currentTarget.style.background = "#4f46e5"; }}
              onMouseLeave={e => { if (!loading) e.currentTarget.style.background = "#6366f1"; }}
            >
              {loading ? "Entrando..." : "Entrar"}
            </button>
          </form>

          {/* Divider + App download */}
          <div style={{ marginTop: 32, borderTop: "1px solid #f1f5f9", paddingTop: 24 }}>
            <p style={{ fontSize: 12, color: "#9ca3af", marginBottom: 14, textAlign: "center" }}>
              Baixe nosso aplicativo
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              <img src={qrcode} alt="qrcode" style={{ width: 56, height: 56, borderRadius: 8 }} />
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <a href="https://play.google.com/store/apps/details?id=br.com.conexo.saude" target="_blank" rel="noreferrer">
                  <img src={google} alt="Google Play" style={{ height: 28, objectFit: "contain" }} />
                </a>
                <a href="https://apps.apple.com/br/app/conexo-saúde/id1542610505?platform=iphone" target="_blank" rel="noreferrer">
                  <img src={apple} alt="App Store" style={{ height: 28, objectFit: "contain" }} />
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ── Painel direito — mockup ────────────────────────────────── */}
      <div style={{
        flex: 1,
        background: "#0f1117",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 40,
        position: "relative",
        overflow: "hidden",
      }}>
        {/* Glow de fundo */}
        <div style={{
          position: "absolute",
          width: 400, height: 400,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(99,102,241,0.15) 0%, transparent 70%)",
          top: "30%", left: "50%",
          transform: "translate(-50%, -50%)",
          pointerEvents: "none",
        }} />

        <div style={{ textAlign: "center", marginBottom: 32, position: "relative" }}>
          <h2 style={{ color: "#f1f5f9", fontSize: 24, fontWeight: 700, margin: "0 0 8px" }}>
            Atendimento digital
          </h2>
          <p style={{ color: "#475569", fontSize: 14, margin: 0 }}>
            Plataforma de videoconferência para atendimento
          </p>
        </div>

        <img
          src={fyndmockup}
          alt="mockup"
          style={{ maxWidth: "80%", maxHeight: "60vh", objectFit: "contain", position: "relative" }}
        />
      </div>
    </div>
  );
}

export default Login;